import { CernUserProfile } from 'oidc-client-ts';
import { useAuth } from 'react-oidc-context';

export const useRole = (role: string) => {
    const { user } = useAuth();
    return (user!.profile as CernUserProfile).cern_roles.includes(role);
};
